import { useCallback, useEffect, Fragment, memo, FC, useMemo } from 'react'
import { useRouter } from 'next/router'

import toast from 'utils/toast'
import { useUserPermissionsManager } from 'contexts/UserPermissionsManager/Provider'
import { getModuleByPathOnURL } from 'utils/module'

type Props = {
  children: JSX.Element
  permissions: (string | undefined)[]
  message?: string
  redirect?: string
}

const HasPermissionsToAccessThisPage: FC<Props> = ({
  children,
  permissions = [],
  message = 'Você não tem permissão',
}) => {
  const { asPath, push } = useRouter()

  const MODULE = useMemo(() => {
    const moduleOnUrl = asPath.split('/')[1]
    return getModuleByPathOnURL(moduleOnUrl)
  }, [asPath])

  const ADMIN_PERMISSION = `IMPACTO-${MODULE.API_NAME}-ADMIN`

  const { userPermissions } = useUserPermissionsManager()

  const checkUserHasPermissions = useCallback(() => {
    if (!userPermissions) return false
    return userPermissions.some((item) => userPermissions.includes(ADMIN_PERMISSION) || permissions.includes(item), [])
  }, [userPermissions])

  useEffect(() => {
    async function checkPermission() {
      const hasPermission = checkUserHasPermissions()
      if (!hasPermission) {
        toast.error(message)
        await push('/')
      }
    }

    checkPermission()
  }, [])

  return <Fragment>{children}</Fragment>
}

export default memo(HasPermissionsToAccessThisPage)
